import React, { useState, useRef, useEffect,useCallback,use } from 'react';
import { Import } from 'lucide-react';
import ProfilerNavBar from '../profilerEditingPage/profilerNavBar';
import { useNavigate, useSearchParams } from 'react-router-dom';
import { resumeUpload } from "../../../supports/resumeUpload";
import { set } from 'lodash';

const EmailValidation = () => {
 const [searchParams] = useSearchParams();
 const[isActivated,setIsActivated]=useState(false)
  const[alreadyActivated,setAlreadyActivated]=useState(false)
  const[isRecruiter,setIsRecruiter]=useState(false) 
  const Key = searchParams.get('key');
  
  useEffect(() => {
     if(!Key){
        return
     }
     activateCandidate()
  }, [Key]);   
  
  useEffect(() => {
    console.log("Activation Key:", isActivated);
    console.log("Already Activated Status:", alreadyActivated); 
  }, []);  


  const activateCandidate= async() =>{
    try {
        let response = await resumeUpload.validateCandidateUser(Key, {});
        if(response.data.is_recruiter){
          setIsRecruiter(true)
        }else{
          setIsRecruiter(false) 
        }
        if(response?.data?.status_code==200){
            setIsActivated(true)
        }
        else if(response?.data.status_code==250){
           setAlreadyActivated(true)
        }
        console.log("Activation response:", response);
    } catch (error) {
    console.log("Error in activating candidate:", error);    
    }

  }
  

  return (
    <div className="w-full relative h-screen bg-white flex flex-col">
      <ProfilerNavBar  />
      <div className='w-full h-full  flex items-center justify-center p-6'>
      <div className='rounded-md bg-white items-center   min-h-[15rem] items-center flex flex-col gap-2 p-12 '>
        {!isActivated && !alreadyActivated &&(
        <div className='h-full w-full flex flex-col items-center justify-center'>
         <div class="loader-container mb-4 transform scale-[0.8] 2xl:scale-100 xl:scale-100 md:scale-100 sm:scale-100">
        <div class="spinner">
            <div class="spinner-ring"></div>
            <div class="mail-icon">
                <svg viewBox="0 0 24 24">
                    <rect x="3" y="5" width="18" height="14" rx="2"/>
                    <path d="M3 7l9 6 9-6"/>
                </svg>
            </div>
        </div>
    </div>
        <div className='text-sm 2xl:text-2xl xl:text-xl md:xl sm:text-xl  font-semibold mb-1 text-[#03644d] '>Verifing Your email addresss</div>
        <div className='text-[0.5rem] 2xl:text-xs xl:text-xs lg:text-xs md:text-xs sm:text-xs  flex items-center text-center  font-semibold'>
            Please wait we will send verification link to your email address to complete the sign-up process.
        </div>
        </div>
        )}
         {isActivated && !alreadyActivated &&(
        <div className='h-full w-full flex flex-col items-center justify-center'>
         <div class="loader-container ">
        <div class="success-icon">
                <div class="success-circle transform scale-[0.8] 2xl:scale-100 xl:scale-100 md:scale-100 sm:scale-100">
                    <svg class="success-checkmark" viewBox="0 0 52 52">
                        <path class="checkmark-path" d="M14 27l10 10 20-20"/>
                    </svg>
                </div>
            </div>
    </div>
        <div className='text-sm 2xl:text-2xl xl:text-xl md:xl sm:text-xl font-semibold mb-1 text-[#03644d] '>Verification Successful!</div>
        <div className='text-[0.5rem] 2xl:text-xs xl:text-xs lg:text-xs md:text-xs sm:text-xs  flex items-center text-center font-semibold'>
           Your email address has been verified successfully. Please login to continue.
        </div>
        <div className='w-full p-1 mt-3 flex items-center justify-center'>
          {isRecruiter ? (
                <a href='/login' className='p-1.5 px-3 bg-[#03644d] rounded text-white text-[0.6rem] 2xl:text-xs xl:text-xs lg:text-xs md:text-xs sm:text-xs font-semibols '>Login</a>
          ):( 
                <a href='/resume-login' className='p-1.5 px-3 bg-[#03644d] rounded text-white text-[0.6rem] 2xl:text-xs xl:text-xs lg:text-xs md:text-xs sm:text-xs font-semibols '>Login</a>
          )}
                </div>
        </div>
        )}
         {!isActivated && alreadyActivated &&(
        <div className='h-full w-full flex flex-col items-center justify-center'>
         <div class="loader-container ">
        <div class="success-icon">
                <div class="success-circle transform scale-[0.8] 2xl:scale-100 xl:scale-100 md:scale-100 sm:scale-100">
                  <svg 
className='success-info'
  version="1.1" 
  id="_x32_" 
  xmlns="http://www.w3.org/2000/svg" 
  xmlnsXlink="http://www.w3.org/1999/xlink" 
  viewBox="0 0 512 512" 
  xmlSpace="preserve" 
  fill="currentColor"
>
  <g id="SVGRepo_bgCarrier" strokeWidth="0"></g>
  <g id="SVGRepo_tracerCarrier" strokeLinecap="round" strokeLinejoin="round"></g>
  <g id="SVGRepo_iconCarrier">
    <style type="text/css">
      {`.st0{fill:#03644d;}`}
    </style>
    <g>
      <path 
        className="st0" 
        d="M290.671,135.434c37.324-3.263,64.949-36.175,61.663-73.498c-3.241-37.324-36.152-64.938-73.476-61.675 c-37.324,3.264-64.949,36.164-61.686,73.488C220.437,111.096,253.348,138.698,290.671,135.434z"
      />
      <path 
        className="st0" 
        d="M311.31,406.354c-16.134,5.906-43.322,22.546-43.322,22.546s20.615-95.297,21.466-99.446 c8.71-41.829,33.463-100.86-0.069-136.747c-23.35-24.936-53.366-18.225-79.819,7.079c-17.467,16.696-26.729,27.372-42.908,45.322 c-6.55,7.273-9.032,14.065-5.93,24.717c3.332,11.515,16.8,17.226,28.705,12.871c16.134-5.895,43.3-22.534,43.3-22.534 s-12.595,57.997-18.869,87c-0.874,4.137-36.06,113.292-2.505,149.18c23.35,24.949,53.343,18.226,79.819-7.066 c17.467-16.698,26.729-27.373,42.908-45.334c6.55-7.263,9.009-14.054,5.93-24.706C336.66,407.733,323.215,402.01,311.31,406.354z"
      />
    </g>
  </g>
</svg>
                </div>
            </div>
    </div>
        <div className=' font-semibold text-sm 2xl:text-2xl xl:text-xl md:xl sm:text-xl mb-1 text-[#03644d] '>Account Already Activated</div>
        <div className='text-[0.5rem] 2xl:text-xs xl:text-xs lg:text-xs md:text-xs sm:text-xs  flex items-center text-center  font-semibold'>
          You have already activated your account. Please log in to continue.
        </div>
        <div className='w-full p-1 mt-3 flex items-center justify-center'>
               {isRecruiter ? (
                <a href='/login' className='p-1.5 px-3 bg-[#03644d] rounded text-white text-[0.6rem] 2xl:text-xs xl:text-xs lg:text-xs md:text-xs sm:text-xs font-semibols '>Login</a>
          ):( 
                <a href='/resume-login' className='p-1.5 px-3 bg-[#03644d] rounded text-white text-[0.6rem] 2xl:text-xs xl:text-xs lg:text-xs md:text-xs sm:text-xs font-semibols '>Login</a>
          )}
            </div>
        </div>
        )}
      </div>
      </div>
    </div>
  );
};

export default EmailValidation;
